import { Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { Qrange } from "../question/qrange.model";
import { QuestionRangeGroupWeighting } from "./question-range-group-weighting.model";

export class QuestionRangeGroup extends BaseModel {
  id: number;
  name: string;
  description: string;
  @Type(() => QuestionRangeGroupWeighting)
  qRangeGroupWs: QuestionRangeGroupWeighting[];
  @Type(() => Qrange)
  questionRanges?: Qrange[];
  qRangeValueCount?: number;
  /** Set automatically once every variant of this group has been archived. */
  isArchived?: number;
  /** Discriminates Range (0) from NPS (1). */
  isForNPS?: number;
}
